import {IconButton} from '@material-ui/core';
import React, {useState} from 'react';
import ContactData from '../Data/ContactData';

function Code() {
    const [links, setLinks] = useState(
        [
            ContactData[0]["link1"],
            ContactData[0]["link2"],
            ContactData[0]["link3"]
        ]
    );
    const [sites, setSites] = useState(
        [
            ContactData[0]["site1"],
            ContactData[0]["site2"],
            ContactData[0]["site3"],
        ]
    );
    const [logos, setLogos] = useState(
        [
            ContactData[0]["logo1"],
            ContactData[0]["logo2"],
            ContactData[0]["logo3"],
        ]
    );
    const [type, setType] = useState(ContactData[0]["type"]);
    
    const codeText = (id) => {
        let tempLinks = [];
        let tempSites = [];
        let tempLogos = [];
        
        setType(ContactData[id]["type"]);
        
        tempLinks.push(ContactData[id]["link1"]);
        tempLinks.push(ContactData[id]["link2"]);
        tempLinks.push(ContactData[id]["link3"]);
        setLinks(tempLinks);
        
        tempSites.push(ContactData[id]["site1"]);
        tempSites.push(ContactData[id]["site2"]);
        tempSites.push(ContactData[id]["site3"]);
        setSites(tempSites);
        
        tempLogos.push(ContactData[id]["logo1"]);
        tempLogos.push(ContactData[id]["logo2"]);
        tempLogos.push(ContactData[id]["logo3"]);
        setLogos(tempLogos);
    }
    
    const openLink = (link) => {
        if (link.includes("@gmail.com")) {
            window.open("mailto:" + link);
        }
        else {
            window.open(link, "_blank");
        }
    }
    
    return (
        <div className="code" data-aos="flip-up" data-aos-delay="400">
            <div className="code__top">
                <div className="code__top__buttons">
                    <IconButton onClick={() => codeText(0)}>
                        <div className="code__top__buttons__1"></div>
                    </IconButton>
                    <IconButton onClick={() => codeText(1)}>
                        <div className="code__top__buttons__2"></div>
                    </IconButton>
                    <IconButton onClick={() => codeText(2)}>
                        <div className="code__top__buttons__3"></div>
                    </IconButton>
                </div>
                <div className="code__top__heading">HaiderSultanArc</div>
            </div>
            <div className="code__body">
                <div className="code__body__line">
                    {">>>"}
                    <span className="code__body__line__keyword">{" import"}</span>
                    <span className="code__body__line__entity">{" handersultanarc"}</span>
                    <span className="code__body__line__keyword">{" as"}</span>
                    <span className="code__body__line__entity">{" hs"}</span>
                </div>
                <div className="code__body__line">
                    {">>>"}
                    <span className="code__body__line__keyword">{" def"}</span>
                    <span className="code__body__line__function">{" contact"}</span>
                    {"(profile):"}
                </div>
                <div className="code__body__line">
                    <span className="code__body__line__space">{"........"}</span>
                    {"profile."}
                    <span className="code__body__line__function">{"showSite"}</span>
                    {"()"}
                </div>
                <div className="code__body__line">
                    <span className="code__body__line__space">{"........"}</span>
                    {"profile."}
                    <span className="code__body__line__function">{"showLogo"}</span>
                    {"()"}
                </div>
                <div className="code__body__line">
                    <span className="code__body__line__space">{"........"}</span>
                    {"profile."}
                    <span className="code__body__line__function">{"showURL"}</span>
                    {"()"}
                </div>
                <div className="code__body__line">
                    {">>>"}
                    <span className="code__body__line__keyword">{" for"}</span>
                    {" profile"}
                    <span className="code__body__line__keyword">{" in"}</span>
                    <span className="code__body__line__entity">{" hs"}</span>
                    {`.${type}Profiles:`}
                </div>
                <div className="code__body__line">
                    <span className="code__body__line__space">{"........"}</span>
                    <span className="code__body__line__function">{"contact"}</span>
                    {"(profile)"}
                </div>
                <div className="code__body__line"></div>
                <div className="code__body__lineOutput" onClick={() => openLink(links[0])}>
                    <div className="code__body__lineOutput__site">{`${sites[0]}:`}</div>
                    {logos[0]}
                    <div className="code__body__lineOutput__link">{`${links[0]}`}</div>
                </div>
                <div className="code__body__line"></div>
                <div className="code__body__lineOutput" onClick={() => openLink(links[1])}>
                    <div className="code__body__lineOutput__site">{`${sites[1]}:`}</div>
                    {logos[1]}
                    <div className="code__body__lineOutput__link">{`${links[1]}`}</div>
                </div>
                <div className="code__body__line"></div>
                <div className="code__body__lineOutput" onClick={() => openLink(links[2])}>
                    <div className="code__body__lineOutput__site">{`${sites[2]}:`}</div>
                    {logos[2]}
                    <div className="code__body__lineOutput__link">{`${links[2]}`}</div>
                </div>
            </div>
        </div>
    );
}

export default Code



// WEBPACK FOOTER //
// ./src/Components/Contact/JavaScript/Code.js